export const TEAMS = {
  MARKETING: 'Marketing',
  CACO: 'CACO',
  SEARCH: 'Search',
  REFERRAL: 'Referral',
  SHARED: 'Shared'
};

export const PAGES = {
  WORKSPACE_SELECTION: '[WorkspaceSelectionPage]',
  SEARCH: '[SearchPage]',
  RESERVABLE: '[ReservablePage]',
  BUILDING: '[BuildingPage]',
  SAKSWORKS: '[SaksworksBuildingPage]', // TODO: It should be removed during process of removing saksworks type of building page
  ENTERPRISE: '[EnterprisePage]',
  EVENTS_CONTACT_US: '[EventsContactUsPage]',
  CONTACT_US: '[ContactUsPage]',
  SILO: '[SiloPage]',
  PRODUCT_DETAILS: '[ProductDetailsPage]',
  WAYSYOUWORK: '[WaysYouWorkPage]',
  HTW_AWARENESS: '[AwarenessPage]',
  HTW_ACQUISITION: '[AcquisitionPage]',
  BROKERS: '[BrokersPage]',
  REFERRAL: '[ReferralPage]',
  PREVIEW_MODULES: '[PreviewModulesPage]',
  OFFER: '[OfferPage]',
  LANDLORDS: '[LandlordsPage]'
};
